export default [
  {
    title: 'Mobility & Flexibility',
    cdnId: 'app_images/exercise-lunge',
    color: 'textPrimary'
  },
  {
    title: 'Balance & Coordination',
    cdnId: 'app_images/exercise-medball',
    color: 'textPrimary'
  },
  {
    title: 'Core & Conditioning',
    cdnId: 'app_images/exercise-medball',
    color: 'textPrimary'
  },
  {
    title: 'BodyF1RST Monthly Subscription',
    cdnId: 'app_images/members-dock',
    color: 'textPrimary'
  }
];
